import gql from 'graphql-tag'
import { CurrentUserFeatures_user } from './CurrentUserProvider.fragments'

const CURRENT_USER_QUERY = gql`
  query CurrentUserProviderQuery {
    viewer {
      id
      firstName
      lastName
      email
      admin
      ...CurrentUserFeatures_user
    }
  }
  ${CurrentUserFeatures_user}
`

export default CURRENT_USER_QUERY



// WEBPACK FOOTER //
// ./src/components/CurrentUserProvider.query.js